import React, { useState } from 'react';
import './EditLeadModal.css';
import AddSpecificationForm from './AddSpecificationForm';

const EditLeadModal = ({
  showEditModal,
  editingLead,
  editFormData,
  handleEditFormChange,
  handleUpdateLead,
  handleCancelEdit,
  isLoading,
  statusOptions,
  activityTypeOptions
}) => {
  const [showSpecForm, setShowSpecForm] = useState(false);
  const [specifications, setSpecifications] = useState([{
    rating: '',
    voltageRatio: '',
    winding: '',
    losses: '',
    tapChanger: '',
    terminal: '',
    qty: ''
  }]);
  const [customSpecs, setCustomSpecs] = useState([]);

  if (!showEditModal) return null;

  const toggleSpecForm = () => {
    setShowSpecForm(!showSpecForm);
  };

  const handleSpecsChange = (newSpecs, newCustomSpecs) => {
    setSpecifications(newSpecs);
    setCustomSpecs(newCustomSpecs);
  };

  return (
    <div className="edit-lead-modal modal-overlay">
      <div className="modal-content">
        <h3>Edit Lead {editingLead}</h3>
        <div className="modal-form">
          <div className="edit-form-group">
            <label>Contact Name:</label>
            <input
              type="text"
              name="contact_name"
              value={editFormData.contact_name}
              onChange={handleEditFormChange}
            />
          </div>
          
          <div className="edit-form-group">
            <label>Company Name:</label>
            <input
              type="text"
              name="company_name"
              value={editFormData.company_name}
              onChange={handleEditFormChange}
            />
          </div>
          
          <div className="edit-form-group">
            <label>Product Name:</label>
            <input
              type="text"
              name="product_name"
              value={editFormData.product_name}
              onChange={handleEditFormChange}
            />
          </div>
          
          <div className="edit-form-group">
            <label>Phone:</label>
            <input
              type="text"
              name="contact_phone"
              value={editFormData.contact_phone}
              onChange={handleEditFormChange}
            />
          </div>
          
          <div className="edit-form-group">
            <label>Email:</label>
            <input
              type="email"
              name="contact_email"
              value={editFormData.contact_email}
              onChange={handleEditFormChange}
            />
          </div>
          
          <div className="edit-form-group">
            <label>Delivery Location:</label>
            <input
              type="text"
              name="delivery_location"
              value={editFormData.delivery_location}
              onChange={handleEditFormChange}
            />
          </div>

          <div className="edit-form-group">
            <label>Status:</label>
            <select
              name="responded"
              value={editFormData.responded}
              onChange={handleEditFormChange}
            >
              <option value="">Select Status</option>
              {statusOptions.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </div>

          {/* Activity Log Fields */}
          <div className="edit-form-group">
            <label>Activity Type:</label>
            <select
              name="activity_type"
              value={editFormData.activity_type || 'call'}
              onChange={handleEditFormChange}
            >
              <option value="">Select Activity Type</option>
              {activityTypeOptions && activityTypeOptions.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </div>
          <div className="edit-form-group">
            <label>Response Notes:</label>
            <textarea
              name="response_notes"
              value={editFormData.response_notes}
              onChange={handleEditFormChange}
              placeholder="Enter activity description"
            />
          </div>
          <div className="edit-form-group">
            <label>Activity Description:</label>
            <textarea
              name="activity_description"
              value={editFormData.activity_description || ''}
              onChange={handleEditFormChange}
              placeholder="Enter activity description"
            />
          </div>

          <div className="modal-buttons">
            <button 
              onClick={toggleSpecForm} 
              disabled={isLoading}
              className="btn add-button"
            >
              {showSpecForm ? 'Hide Specifications' : 'Add Specifications'}
            </button>

            <button 
              onClick={() => {
                const updatedData = {
                  ...editFormData,
                  specifications,
                  customSpecs
                };
                handleUpdateLead(updatedData);
              }} 
              disabled={isLoading}
              className="save-button"
            >
              {isLoading ? 'Saving...' : 'Save Changes'}
            </button>
            <button 
              onClick={handleCancelEdit} 
              disabled={isLoading}
              className="cancel-button"
            >
              Cancel
            </button>
          </div>

          {showSpecForm && (
            <AddSpecificationForm
              initialSpecifications={specifications}
              initialCustomSpecs={customSpecs}
              onSpecsChange={handleSpecsChange}
              onClose={toggleSpecForm}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EditLeadModal;
